import React from "react";
import { useRef } from "react";
import "./Information.css";
import informationImage from "../../../images/ellipseInfo.png";
import egrulImage from "../../../images/svidetelstvoEgrul.jpg";
import innImage from "../../../images/svidetelstvoInn.jpg";
import oremImage from "../../../images/svidetelstvoOrem.jpg";
import npsrImage from "../../../images/svidetelstvoNpsr.jpg";
import rekvizityImage from "../../../images/rekvizity.jpg";

function Information({ isActiveInformation, scrollItem, onScrollItem }) {
  const informationRef = useRef();

  React.useEffect(()=>{
    if (scrollItem === "information") {
      onScrollItem(informationRef);
    }
  },[onScrollItem,scrollItem])

  return (
    <section ref={informationRef} className={`information page__container inactive ${isActiveInformation ? "active" : ""}`}>
      <img
        className="information__image"
        src={informationImage}
        alt="Изображение информации"
      ></img>
      <div className="information__container">
        <h2 className="information__title">Информация о компании</h2>
        <ul className="information__text-container">
          <li className="information__text">
            <a
              className="information__text-link"
              href={egrulImage}
              target="_blank"
              rel="noopener noreferrer"
            >
            Свидетельство о государственной регистрации
            </a>
          </li>
          <li className="information__text">
            <a
              className="information__text-link"
              href={innImage}
              target="_blank"
              rel="noopener noreferrer"
            >
            Свидетельство о постановке на учет в налоговом органе
            </a>
          </li>
          <li className="information__text">
            <a
              className="information__text-link"
              href={oremImage}
              target="_blank"
              rel="noopener noreferrer"
            >
            Свидетельство о статусе субъекта ОРЭМ
            </a>
          </li>
          <li className="information__text">
            <a
              className="information__text-link"
              href={npsrImage}
              target="_blank"
              rel="noopener noreferrer"
            >
            Свидетельство о членстве в НП «Совет рынка»
            </a>
          </li>
          <li className="information__text">
            <a
              className="information__text-link"
              href={rekvizityImage}
              target="_blank"
              rel="noopener noreferrer"
            >
            Реквизитная карточка
            </a>
          </li>
          <li className="information__text">
            <a
              className="information__text-link"
              href="https://cloud.mail.ru/public/9BSJ/be44sMDY5"
              target="_blank"
              rel="noopener noreferrer"
            >
            Раскрытие информации
            </a>
          </li>
        </ul>
      </div>
    </section>
  );
}

export default Information;
